import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectInstoreIsSMSFeatureEnabled } from 'core/selectors/app';
import { selectCookieDomain, selectIsHttps } from 'core/selectors/env';
import LinkLoader from 'core/modules/LinkLoader/LinkLoader';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { postInstoreCardLink } from 'core/actions/member';
import { showModal } from 'core/modules/OldModal/actions';
import { MODAL_TYPE_INSTORE_HIW } from 'core/modules/OldModal/types';
import { selectInstoreLinkCardIsLoading, selectInstoreLinkCardIsLoaded } from './selector';

import './CardLinkOffer.scss';
import {
  OFFER_LINK_HIW_FIRST_TYPE, OFFER_LINK_HIW_SECOND_TYPE,
} from '../../OldModal/components/InstoreHiwModal/types/types';
import { instoreAddNewCardOverlayClick } from '../OffersSection/actions';
import { triggerOfferIsLinked } from '../OffersSection/analytics/types';
import { setInstoreInfoCookie } from '../../../utils/helpers/instoreInfoCookie';

function CardLinkOffer({
  offerId, merchantName, merchantNameAndGmid, redemptionEndDate, paymentCard = {},
  children, cardsAvailable, styleExists,
}) {
  const cookieDomain = useSelector(selectCookieDomain);
  const isHttps = useSelector(selectIsHttps);
  const instoreLinkCardIsLoaded = useSelector(selectInstoreLinkCardIsLoaded);
  const instoreLinkCardIsLoading = useSelector(selectInstoreLinkCardIsLoading);
  const isInstoreSMSFeatureEnabled = useSelector(selectInstoreIsSMSFeatureEnabled);

  const dispatch = useDispatch();
  const totalSteps = isInstoreSMSFeatureEnabled ? '3' : '2';
  const HIW_HEADER_FIRST_TIME = `${totalSteps} steps to earn in store miles at ${merchantName}`;
  const HIW_HEADER_SECOND_TIME = 'Maximize your in store experience';

  const [showLoadingIcon, setShowLoadingIcon] = useState(false);
  const URL_INFO = `&offerId${offerId}&merchantName${merchantName}&originator=offers`;

  useEffect(() => {
    if (instoreLinkCardIsLoaded) {
      setShowLoadingIcon(false);
    }
  }, [instoreLinkCardIsLoaded]);

  const instoreCardLink = () => {
    dispatch(postInstoreCardLink(offerId, paymentCard));
    if (!styleExists) {
      dispatch(triggerOfferIsLinked(merchantNameAndGmid));
    }
    setShowLoadingIcon(true);
  };

  const triggerAddNewCardOverlay = () => {
    dispatch(dispatch(instoreAddNewCardOverlayClick({
      offerId,
      urlInfo: URL_INFO,
      merchantName,
    })));
  };

  const isAddCardOnboardingComplete = () => window.instoreData && window.instoreData.isAddCardOnBoardingComplete;

  const isLinkingOnboardingComplete = () => window.instoreData && window.instoreData.isLinkingOnBoardingComplete;

  const showOnboardingFlow = () => {
    dispatch(showModal(MODAL_TYPE_INSTORE_HIW, {
      type: OFFER_LINK_HIW_FIRST_TYPE,
      header: HIW_HEADER_FIRST_TIME,
      offerId,
      merchantName,
      urlInfo: URL_INFO,
    }));
  };

  const showPostLinkOnboarding = () => {
    instoreCardLink();
    window.instoreData.isLinkingOnBoardingComplete = true;
    setInstoreInfoCookie(cookieDomain, isHttps);
    dispatch(showModal(MODAL_TYPE_INSTORE_HIW, {
      type: OFFER_LINK_HIW_SECOND_TYPE,
      header: HIW_HEADER_SECOND_TIME,
      offerId,
      redemptionEndDate,
    }));
  };

  const handleLinkClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!cardsAvailable || cardsAvailable === 0) {
      if (isAddCardOnboardingComplete()) {
        triggerAddNewCardOverlay();
      } else {
        showOnboardingFlow();
      }
    } else if (isLinkingOnboardingComplete()) {
      instoreCardLink();
    } else {
      showPostLinkOnboarding();
    }
  };

  return (
    <ComponentErrorBoundary>
      {showLoadingIcon && instoreLinkCardIsLoading ?
        <LinkLoader /> :
        <button
          className={`${styleExists || 'mn_button mn_instoreCardLinkOffer'}`}
          data-test="link-offer-modal"
          data-gmid-and-merchant-name={merchantNameAndGmid}
          onClick={handleLinkClick}
        >
          {children}
        </button>
      }
    </ComponentErrorBoundary>
  );
}

export default CardLinkOffer;
